<template>
    <div class="reply-item">
        <div :class="['reply-content', reply.display === 1 ? '' : 'reply-shield']">
            <div :class="['hd', parent && parent.createUserName ? 'parent' : '']">
                <div class="name" v-if="parent && parent.createUserName">{{ reply.createUserName }} <span>回复了</span> {{ parent.createUserName }} </div>
                <div class="name" v-else>{{ reply.createUserName }}</div>
            </div>
            <div class="bd">
                <div class="text">{{ reply.content }}</div>
                <div v-if="reply.photoList" class="image">
                    <el-image style="width: 40px; height: 40px;" v-for="(image, index) in reply.photoList" fit="cover" :src="image" :preview-src-list="[image]" :key="index">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </div>
                <p v-if="reply.display === 0" class="shield-text">(该回复已被屏蔽)</p>
            </div>
            <div class="ft">
                <div class="operation">
                    <el-button type="text" @click="onReply(reply)">回复</el-button>
                    <el-button class="btn-display" type="text" @click="onDisplay(reply)">{{ reply.display === 0 ? '展示' : '屏蔽' }}</el-button>
                </div>
            </div>
        </div>
        <div v-if="reply.letterInfoVOList && reply.letterInfoVOList.length > 0" class="reply-children">
            <reply @onReply="onReply" :parent="reply" @onDisplay="onDisplay" v-for="item in reply.letterInfoVOList" :key="item.id" :reply="item" ></reply>
        </div>
    </div>
</template>

<script>
export default {
    name: 'reply',
    props: {
        reply: {
            type: Object,
            default: () => {}
        },
        parent: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {};
    },
    methods: {
        onDisplay(reply) {
            this.$emit('onDisplay', reply);
        },
        onReply(reply) {
            this.$emit('onReply', reply);
        }
    },
};
</script>

<style lang="scss" scoped>
.reply-item {
    .reply-content {
        border-bottom: 1px solid #ebeef5;
        padding: 15px 0 20px;
        .hd {
            line-height: 20px;
            position: relative;
            .name {
                color: #333;
                margin-bottom: 10px;          
                font-weight: 500;
                font-size: 14px;
                span {
                    color: #757575;
                    margin: 0 10px;
                }
            }
            &.parent::before {
                content: "";
                width: 12px;
                height: 10px;
                background: url('~@/assets/img/reply.png') no-repeat center;
                background-size: cover;
                position: absolute;
                top: 5px;
                left: -20px;
            }
        }
        .bd {
            margin-bottom: 10px;
            .text {
                color: #999;
            }
            .image {
                margin-top: 10px;
            }
            .el-image {
                margin-right: 5px;
                margin-bottom: 5px;
            }
            .shield-text {
                font-size: 12px;
                margin-top: 10px;
            }
        }
        .ft {
            .el-button {
                padding: 6px 0px;
            }
        }
        &.reply-shield {
            .btn-display {
                color: #E98800;
            }
            .name, .text {
                color: #c0c4cc;
            }
        }
    }
    .reply-children {
        margin-left: 60px;
    }
}
</style>